import { DwUser } from "@devwareapps/devware-cap";
import { AviatorOnlineUserTypeIds } from "./aviator-user-type.enum";
import { AdminUserProperties } from "../../admin/models/admin-user-properties.model";

export class AviatorUser
{
    user: DwUser;

    UserTypeId: AviatorOnlineUserTypeIds;
    /**
     * Flight school for user with Admin override ability
     */
    FlightSchoolId: number;

    /**
     * Flight school name with Admin override ability
     */
    FlightSchoolName: string;

    /**
     * Flight school branding with Admin override ability
     */
    FlightSchoolBrandingThemeId: number;

    /**
     * Flight school user is assigned to
     */
    RealFlightSchoolId: number;

    constructor(user: DwUser, adminUserProperties: AdminUserProperties) {
        this.setupUser(user, adminUserProperties);
    }

    private setupUser(user: DwUser, adminUserProperties: AdminUserProperties) {
        this.user = user;

        this.RealFlightSchoolId = this.getExtenedAttributeInt("FlightSchoolId");
        this.UserTypeId = adminUserProperties?.userTypeMode || this.getExtenedAttributeInt('UserTypeId');
        this.FlightSchoolId = adminUserProperties?.flightSchoolId || this.RealFlightSchoolId;
        this.FlightSchoolName = adminUserProperties?.flightSchoolName || this.getExtenedAttribute('FlightSchoolName');
        this.FlightSchoolBrandingThemeId = adminUserProperties?.flightSchoolBrandingThemeId || this.getExtenedAttributeInt('FlightSchoolBrandingThemeId');
    }

    private getExtenedAttribute(name: string): string {
        const userTypeAttr = this.user?.ExtendedAttributes?.find(a => a.AttrName==name);

        if (userTypeAttr) {
            return userTypeAttr.AttrValue
        }

        return null;
    }

    public hasPermission(permission: string): boolean {
        return this.user?.Permissions?.includes(permission);
    }

    
    private getExtenedAttributeInt(name: string): number {
        const value = this.getExtenedAttribute(name);

        if (value) {
            return parseInt(value);
        }

        return null;
    }

}